/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */

/**
 * Portal 布局组件
 */
import CustomerServiceFloat from './common/CustomerServiceFloat';
import Footer from './portal/Footer';
import { Question, SelectLang } from './portal/RightContent';
import {
  AvatarDropdown,
  AvatarName,
} from './portal/RightContent/AvatarDropdown';
import CustomerService from './portal/RightContent/CustomerService';
import SubAppErrorPage from './portal/SubAppErrorPage';

export {
  AvatarDropdown,
  AvatarName,
  CustomerService,
  CustomerServiceFloat,
  Footer,
  Question,
  SelectLang,
  SubAppErrorPage,
};
